import React from "react";
import "./main.css";
import MainTop from "./containers/mainTop/MainTop";
import MainWorks from "./containers/mainWorks/MainWorks";
import MainExamples from "./containers/mainExamples/MainExamples";
import BtnOrder from "../buttons/order/BtnOrder";
import { useTranslation } from "react-i18next";

export default function Main() {
    const { t } = useTranslation();

    return (
        <div className="main">
            <div className="main__container">
                <MainTop />
                <div className="main__btn__container">
                    <BtnOrder name={t("main_top_button")} />
                </div>
                <MainWorks />
                <div className="main__btn__container">
                    <BtnOrder name={t("main_top_button")} />
                </div>
                <MainExamples />
            </div>
        </div>
    );
}
